import { Component,Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { ReportService } from 'src/shared/services/report.service';
import { Observable, Subscription, from } from 'rxjs';
import { ReportData } from 'src/shared/models/report-data.model';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
  selector: 'smt-acuity-trends-report',
  templateUrl: './acuity-trends-report.component.html',
  styleUrls: ['./acuity-trends-report.component.scss']
})
export class AcuityTrendsReportComponent implements OnInit {
  reportData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  chart: Chart;
  loading: boolean;
  reportSubscription : Subscription;

  private readonly reportNanme = 'Activity Trends';
  private readonly legendName = 'Activity Category';
  private readonly yAxisName = 'Total Count';
  private filterEventSubscription: Subscription;

  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters:ReportFilters;

  @Output() dataUpdated = new EventEmitter();

  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawChart();
    this.loading = true;
    if(this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.loadReportData());
  }

  drawChart(data: string[] = [])
  {
    this.chart = this.chartDefinition.getColumnTemplate(
      this.reportNanme,
      this.reportFilters.ReportView,
      this.yAxisName,
      data,
      false,
      this.legendName
    );
  }

  drawGrid()
  {
    if (!this.reportData)
      return;
      
    this.drawChart(this.reportData.xAxis);

    let chartData = MiscUtil.getDataFilteredByDataSetName(this.reportData);
    if (chartData.length == 0) {
      return;
    }


    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    let lastItem = chartData.pop();
    
    chartData.forEach(dataSet => {
      this.chart.addSeries({type: 'line', name: dataSet.name,	data: dataSet.data}, false, true);
    });

    this.chart.addSeries({type: 'line', name: lastItem.name, data: lastItem.data}, true, true);
    chartData.push(lastItem);
  }

  async loadReportData()
  {
    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.getAcuityTrendsReport(this.reportFilters))
                                                      .subscribe(x =>
                                                      {
                                                        this.reportData = x ;
                                                        this.dataUpdated.emit(this.reportData);
                                                        this.drawGrid();
                                                        this.loading = false;
                                                      });
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe();
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
}

}
